export function Spinner({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 50 50" className={`animate-kiosk-spin ${className}`} aria-hidden="true">
      <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" strokeOpacity="0.2" strokeWidth="5" />
      <path d="M25 5a20 20 0 0 1 20 20" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}
